import { render, staticRenderFns } from "./PaymentDetailPage.vue?vue&type=template&id=2c666615&scoped=true&"
import script from "./PaymentDetailPage.vue?vue&type=script&lang=ts&"
export * from "./PaymentDetailPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c666615",
  null
  
)

export default component.exports